module.exports = "<div class=\"wrapper overflow\" [ngClass]=\"classes\">\r\n  <ng-content></ng-content>\r\n</div>\r\n"